

























































import { mapGetters } from "vuex";

export default {
  name: "TimelineItem",
  props: {
    title: {
      type: String,
      default: ""
    },
    dateTitle: {
      type: Date,
      default: null
    },
    remainTime: {
      type: String,
      default: null
    },
    stepValue: {
      type: String,
      default: ""
    },
    statusColor: {
      type: String,
      default: "default"
    },
    statusSize: {
      type: String,
      default: "is-small"
    },
    hideProgressLine: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      isMobile: "isMobile"
    })
  }
};
